export class WellSchematicUi {
    public constructor(init?: Partial<WellSchematicUi>) {
        this.currentStageOnly = init && init.currentStageOnly || false;
        this.drawNoLabels = init && init.drawNoLabels || false;
        this.drawWater = init && init.drawWater !== undefined ? init.drawWater : false;
    }
    currentStageOnly: boolean;
    drawNoLabels: boolean;
    drawWater: boolean;
}
